// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--dialog-card-text-padding:0 24px}@media only screen and (max-width:701px){:root{--dialog-card-text-padding:0 16px}}.theme--light.v-label{color:#0f172a}.theme--light.v-label--is-disabled{color:rgba(15,23,42,.38)}.theme--dark.v-label{color:#f8fafc}.theme--dark.v-label--is-disabled{color:rgba(248,250,252,.5)}.v-label{font-size:16px;line-height:1;min-height:8px;transition:.3s cubic-bezier(.25,.8,.5,1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
